import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { driver } from '../models/driver.model'; 

@Injectable({
  providedIn: 'root'
})
export class DriverService {

  constructor(private _http : HttpClient) { }

  getBlankDriver() : Observable<any>{

    return this._http.get<any>(environment.config.BASE_API_URL + "Driver/GetBlankDriver");
  }

  getDrivers(pageNo, pageSize) : Observable<any>{

    return this._http.get<any>(`${environment.config.BASE_API_URL}Driver/GetDrivers?pageNo=${pageNo}&pageSize=${pageSize}`);
  }

  saveDriver(mod : driver) : Observable<any>{
    let viewModel = {
      Driver : mod
    };
    return this._http.post<any>(environment.config.BASE_API_URL + 'Driver/PostDriver', viewModel);
  }

  changePassword(mod):Observable<any>{
   
    return this._http.post<any>(environment.config.BASE_API_URL + 'Driver/PostChangePassword', mod);
  }

  getChangePassword(driverId:any) : Observable<any>{
    return this._http.get<any>(`${environment.config.BASE_API_URL}Driver/GetChangePassword?driverId=${driverId}`)
  }


  

}
